import { OffsetPaginationMetaEntity } from "@/entities/OffsetPaginationEntity";

import { ReviewsPaginationMetaSdkDto } from "../types";

export function mapReviewsPaginationMetaToSdkDto(
    paginationMeta: OffsetPaginationMetaEntity
): ReviewsPaginationMetaSdkDto {
    return {
        perPage: paginationMeta.perPage,
        totalCount: paginationMeta.totalCount,
        currentOffset: paginationMeta.currentOffset,
    };
}
